<div
  [formGroup]="filterForm"
  class="flex relative flex-col w-full gap-y-3 grow-0 justify-center items-center max-h-[83vh] h-[83vh] overflow-hidden"
>
  <div class="w-full flex gap-x-6 lg:flex-row items-center flex-wrap gap-y-3 relative">
    <button class="absolute top-0 right-0 z-10" mat-icon-button color="warn" (click)="onNoClick()">
      <mat-icon class="fill-red-500 text-red-500">close</mat-icon>
    </button>

    <div class="flex flex-col gap-y-1 md:w-fit w-full">
      <h3 class="font-semibold w-full text-2xl">Agregar Productos</h3>
      <span *ngIf="limit" class="w-full">Selecciona los productos que deseas agregar con un maximo de {{ limit }} productos</span>
      <span *ngIf="!limit">Selecciona los productos a agregar</span>
    </div>

    <div class="w-full flex justify-between gap-x-6 flex-col md:flex-row">
      <mat-form-field class="lg:max-w-[500px] w-full">
        <input formControlName="search" matInput type="text" placeholder="Buscar artículos por nombre, codigo, categoria..." />
      </mat-form-field>

      <div class="flex gap-x-4">
        <button
          *ngIf="data.productsSelected"
          (click)="checkProductsSelected()"
          [disabled]="productsToAdd.length === 0"
          type="submit"
          mat-flat-button
          color="primary"
        >
          <span class=""> Revisar Seleccion </span>
        </button>
        <button (click)="closeModalWithData()" [disabled]="productsToAdd.length === 0" type="submit" mat-flat-button color="primary">
          <mat-icon>add</mat-icon>
          <span>
            Agregar
            <span *ngIf="productsToAdd.length > 0">({{ productsToAdd.length }})</span>
            productos
          </span>
        </button>
      </div>
    </div>

    <!-- <div class="flex gap-x-4 w-full">
      <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full max-w-[300px]">
        <mat-label> Seleccionar categoría </mat-label>
        <input
          formControlName="category"
          type="text"
          placeholder="Escribe el nombre de una categoría"
          aria-label="Nombre de categoría"
          matInput
          [matAutocomplete]="autoCategories"
        />
        <mat-autocomplete [displayWith]="displayCategory" #autoCategories="matAutocomplete">
          <mat-option [value]=""> Todas las categorías </mat-option>
          <mat-option *ngFor="let category of filteredCategories" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full max-w-[300px]">
        <mat-label> Seleccionar subcategoría </mat-label>
        <input
          formControlName="subCategory"
          type="text"
          placeholder="Escribe el nombre de una subcategoría"
          aria-label="Nombre de subcategoría"
          matInput
          [matAutocomplete]="autoSubcategories"
        />
        <mat-autocomplete [displayWith]="displaySubCategory" #autoSubcategories="matAutocomplete">
          <mat-option [value]=""> Todas las subcategorías </mat-option>
          <mat-option *ngFor="let subcategory of filteredSubCategories" [value]="subcategory.id">
            {{ subcategory.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div> -->
  </div>
  <div class="overflow-auto mb-auto w-full h-full grow flex flex-col">
    <div class="w-[1200px] md:w-full h-full grow flex flex-col">
      <table class="w-full ">
        <thead class="sticky top-0 z-20 max-w-full ">
          <tr>
            <th>
              <button
                [matTooltip]="
                  productsToAdd.length === limit ? 'Cuidado esto eliminara la seleccion anterior' : 'Seleccionar todos en la pagina actual'
                "
                (click)="$event.stopPropagation()"
              >
                <mat-checkbox color="primary" [checked]="AllSelectedProductsIsTrue()" (change)="selectTopTenProducts($event)"></mat-checkbox>
              </button>
            </th>
            <th>Codigo</th>
            <th>Nombre</th>
            <th>Categoria</th>
            <th>Subcategoria</th>
            @if (canViewInventory) {
              <th>Stock</th>
            }
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody class="" *ngIf="filteredProducts?.length > 0">
          <tr *ngFor="let product of filteredProducts">
            <td>
              <button
                [matTooltip]="
                  productsToAdd.length === limit && !productExistsWithoutAlert(product) ? 'No puedes agregar mas productos' : 'Agregar producto'
                "
              >
                <mat-checkbox
                  [disabled]="productsToAdd.length === limit && !productExistsWithoutAlert(product)"
                  color="primary"
                  [checked]="productExistsWithoutAlert(product)"
                  (change)="addProductOnCheck(product, $event)"
                ></mat-checkbox>
              </button>
            </td>
            <td>{{ product?.code }}</td>
            <td>{{ product?.name }}</td>
            <td>{{ product.subCategory?.category?.name }}</td>
            <td>{{ product.subCategory?.name }}</td>
            @if (canViewInventory) {
              <td>{{ product.currentStock | number }}</td>
            }
            <!-- <td>
              <div *ngIf="product.code === 'ART999999'">
                <mat-form-field class="">
                  <mat-label>Cantidad</mat-label>
                  <input
                    formControlName="genericItemQuantity"
                    type="number"
                    placeholder="Ingresar cantidad articulo generico"
                    matInput
                  />

                  <mat-error
                    *ngIf="filterForm.controls.genericItemQuantity?.errors?.['maxLength']"
                    class="mt-2"
                  >
                    Sobre pasa la cantidad de articulos a agregar
                  </mat-error>
                </mat-form-field>
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>

      <div class="flex items-center justify-center flex-col space-y-4 py-16 mb-auto h-full w-full grow" *ngIf="filteredProducts?.length === 0">
        <div class="w-20 h-20 p-4 items-center justify-center flex rounded-full bg-slate-100 dark:bg-card">
          <mat-icon [inline]="true" svgIcon="mat_solid:search_off"></mat-icon>
        </div>
        <span class="text-lg font-semibold max-w-1/2 text-center"> No se encontraron productos con los criterios de búsqueda seleccionados. </span>
      </div>

      <mat-paginator
        class="w-full bg-gray-100 dark:bg-[#2E2E2E] sticky bottom-0 z-20 max-w-full flex justify-start mt-auto"
        [length]="pagination.length"
        [pageIndex]="pagination.pageIndex"
        [pageSize]="pagination.pageSize"
        [pageSizeOptions]="[10]"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>
  </div>

  <!-- <mat-paginator
    class="bg-gray-100 rounded-md w-full h-[70px] hidden md:flex z-50 flex-col md:flex-row items-center mt-auto absolute bottom-0"
    [length]="pagination.length"
    [pageIndex]="pagination.pageIndex"
    [pageSize]="pagination.pageSize"
    [pageSizeOptions]="[10]"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator> -->
</div>
